export class RiskPageData {
  readonly pages?: any;
  readonly entityId?: number;
  readonly userRank?: number;
  readonly icd?: string;
  readonly hcc?: string;
  readonly vrc?: string;
  readonly chaseId?: number;
  readonly finalRank?: number;
  readonly sourceTypeName?: string;
  readonly startDate?: string;
  readonly endDate?: string;
  readonly cmsModel?: string;
  readonly reveleerRank?: number;
  readonly reportingStatusName?: string;
  readonly encounterType?: string;
  readonly paymentYear?: number;
  readonly planId?: string;
  readonly product?: string;
  readonly hccValidationResult?: string;

  constructor(options: {
    pages?: any;
    entityId?: number;
    userRank?: number;
    icd?: string;
    hcc?: string;
    vrc?: string;
    chaseId?: number;
    finalRank?: number;
    sourceTypeName?: string;
    startDate?: string;
    endDate?: string;
    cmsModel?: string;
    reveleerRank?: number;
    reportingStatusName?: string;
    encounterType?: string;
    paymentYear?: number;
    planId?: string;
    product?: string;
    hccValidationResult?: string;
  }) {
    this.pages = options.pages;
    this.entityId = options.entityId;
    this.userRank = options.userRank;
    this.icd = options.icd;
    this.hcc = options.hcc;
    this.vrc = options.vrc;
    this.chaseId = options.chaseId;
    this.finalRank = options.finalRank;
    this.sourceTypeName = options.sourceTypeName;
    this.startDate = options.startDate;
    this.endDate = options.endDate;
    this.cmsModel = options.cmsModel;
    this.reveleerRank = options.reveleerRank;
    this.reportingStatusName = options.reportingStatusName;
    this.encounterType = options.encounterType;
    this.paymentYear = options.paymentYear;
    this.planId = options.planId;
    this.product = options.product;
    this.hccValidationResult = options.hccValidationResult;
  }
}
